class AdpDonutChartController {
  constructor() {
    this.name = 'adpDonutChart';
    this.data = {
      background: {
        height: 0,
        width:0,
        cx: 0,
        cy: 0,
        r: 0
      } 
    };
  }
}

export default AdpDonutChartController;



// WEBPACK FOOTER //
// ./src/app/components/adpDonutChart/adpDonutChart.controller.js